import React, { Suspense, useEffect } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./scss/style.scss";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import ProtectedRoutes from "./auth/ProtectedRoutes";
import Auth from "./auth/Auth";
import { removeAuthToken } from "./redux/actions/authTokenAction";
import { removeLoginUser } from "./redux/actions/userAction";
import { dashboardViewAction } from "./redux/actions/dashboardViewAction";
import { useDispatch, useSelector } from "react-redux";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const ForgotPassword = React.lazy(() =>
  import("./views/pages/forgotpassword/ForgotPasswordForm")
);
const ResetPassword = React.lazy(() =>
  import("./views/pages/passwordforgot/PasswordForgate")
);

const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const Login = React.lazy(() => import("./views/pages/login/LoginPage"));

function App() {


  const navigate = useNavigate();
  const dispatch = useDispatch()
 const isTokenVadid =  useSelector((state)=>state.projectDetails)


  useEffect(() => {
    const tokeninfo1 = localStorage.getItem("tokeninfo");
    const tokeninfo = tokeninfo1 ? JSON.parse(tokeninfo1) : null;
    if (tokeninfo) {
      Auth.signin(() => {
        navigate('/projects')
      })
    } else {
      Auth.signout(() => {
        removeLocalStorage();
        dispatch(removeAuthToken(null));
        dispatch(removeLoginUser({}));
        dispatch(dashboardViewAction(false))
        navigate("/login");
      })
    }

    function removeLocalStorage () {
      localStorage.removeItem('tokeninfo');
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('userAddress');
      localStorage.removeItem('teanatType');
      localStorage.removeItem('tenantMemberData');
    }
  }, [])

  useEffect(() => {
   

    // function removeLocalStorage () {
    //   localStorage.removeItem('tokeninfo');
    //   localStorage.removeItem('loginInfo');
    //   localStorage.removeItem('userAddress');
    //   localStorage.removeItem('teanatType');
    //   localStorage.removeItem('tenantMemberData');
    // }

    if(isTokenVadid && isTokenVadid == "tokenInvalid"){
      console.log("this is value last for token valid ")
      Auth.signout(() => {
        // removeLocalStorage();
        dispatch(removeAuthToken(null));
        dispatch(removeLoginUser({}));
        dispatch(dashboardViewAction(false))
        navigate("/login");
        //  removeLocalStorage();
      })
    }

  }, [isTokenVadid])
  



  return (
    <Suspense fallback={loading}>
      <Routes>
        {Auth.getAuth() ? <>
          <Route path="/" element={<ProtectedRoutes />}>
            <Route
              path="*"

              element={<DefaultLayout />}
            />
          </Route>
        </> : <>
        
          <Route path="*" element={<Login />} />
          <Route path="/404" element={<Page404 />} />
          <Route path="/500" element={<Page500 />} />
          {/* sent mail for forgate password*/}
          {/* <Route
          path="/forgotpassword"
          element={<ForgotPassword />}
        /> */}
          {/* password forgate create new password */}
          {/* <Route
          
          path="/passwordforgot"
     
          element={<ResetPassword />}
        /> */}
        </>}



      </Routes>
    </Suspense>
  );

}

export default App;
